import { EntityOption } from '@context/shared/types/common';
import { ApplicationType } from '../types';

export class ApplicationTypeOption extends EntityOption<ApplicationType> {
	protected override toString() {
		return this.data.name;
	}
}
